<template>
  <span>
    <a
        v-if="to"
        :href="linkUrl"
        :target="target"
        :class="linkClasses"
        @click.exact="handleCheckClick($event, false)"
        @click.ctrl="handleCheckClick($event, true)"
        @click.meta="handleCheckClick($event, true)"
    >
      <slot></slot>
    </a>
    <span v-else :class="linkClasses">
      <slot></slot>
    </span>
    <bcc-icon :class="separatorClasses" type="ic_enter" />
  </span>
</template>

<script>
import BccIcon from '../icon'
import mixinsLink from '../../mixins/link'
const prefixCls = 'bcc-breadcrumb-item'

export default {
  name: 'BccBreadcrumbItem',
  mixins: [mixinsLink],
  components: {
    BccIcon
  },
  data () {
    return {

    }
  },
  computed: {
    linkClasses () {
      return `${prefixCls}-link`
    },
    separatorClasses () {
      return `${prefixCls}-separator`
    }
  },
  mounted () {
  }
}
</script>
